import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function StarIcon({ height = 60, width = 60, color = 'white', ...props }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path d="m11.4444 3.76051c.2032-.49758.9078-.49758 1.111 0l2.1146 5.17793 5.5131.45059c.5289.04319.7456.70117.3457 1.04997l-4.2088 3.6727 1.2821 5.4756c.1143.4881-.3783.8772-.8145.6914l-.0867-.0451-4.701-2.925-4.70097 2.925-.08671.0451c-.43621.1858-.92875-.2033-.81446-.6914l1.28203-5.4756-4.20879-3.6727c-.39983-.3488-.18317-1.00678.34571-1.04997l5.51308-.45059zm-.8648 5.68828c-.1923.47091-.63269.79411-1.13965.83551l-3.74355.3053 2.87109 2.5049c.37651.3286.54104.8382.42715 1.3248l-.86953 3.7096 3.16169-1.9664.0832-.0481c.4221-.2227.9337-.2066 1.343.0481l3.1611 1.9664-.8689-3.7096c-.1139-.4866.0506-.9962.4271-1.3248l2.8705-2.5049-3.7429-.3053c-.507-.0414-.9474-.3646-1.1397-.83551l-1.4203-3.47812z" fill={color} />
    </SVGWrapper>
  );
}

export default StarIcon;
